import { useState, useEffect } from "react";
import DataFrame from "../../components/DataFrame/DataFrame";
import { apiClient } from "../../api/api-client";
import { useLocation, useNavigate } from "react-router";
import Logo from "../../components/Logo";
import Input from "heroic-ui-library/dist/components/Input";
import Button from "heroic-ui-library/dist/components/Button";
import Loading from "react-loading";
import { InfoData } from "../../lib/type";
import Cookies from "js-cookie";
import TutorialFrame from "./../../components/TutorialFrame";
import { AnimatePresence, motion } from "framer-motion";

function ParentBinder() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [info, setInfo] = useState<InfoData>({} as InfoData);
  const [helpwindow, setHelpwindow] = useState(false);

  const { state } = useLocation();
  const nav = useNavigate();
  const [code, setCode] = useState(state?.child_code);

  const gotoParentPage = () => {
    const parent_code_updated = Cookies.get("parent_code") + "";
    nav(`${"/parent_code/" + parent_code_updated}`);
  };

  useEffect(() => {
    const parent_code_cookie = Cookies.get("parent_code");
    const parent_code =
      parent_code_cookie != undefined ? parent_code_cookie + "" : "";

    apiClient.getParentInformation(parent_code).then(async (resp) => {
      if (resp.code === 200) {
        setInfo(resp);
      } else setError("Failed to connect to server, Please try again later");
    });
  }, []);

  const connectChild = async () => {
    if (!code) return setError("Please enter child code");

    setIsLoading(true);

    const response = await apiClient.bindChildCode(code);

    if (response.code == 200) {
      if (Cookies.get("redirect") == "true") {
        window.location.href =
          "https://parent.heroicgameday.com/dashboard/?parent_code=" +
          Cookies.get("parent_code");
      } else {
        gotoParentPage();
      }
    } else if (response.code == 400) {
      setError(response.msg);
    }

    setIsLoading(false);
  };

  return (
    <div className="flex flex-col h-full relative justify-center items-center">
      <div className="absolute left-6 top-6">
        <Logo />
      </div>
      <AnimatePresence>
        {!helpwindow && (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
            <DataFrame>
              <div className="w-full h-full flex flex-col space-y-2 items-center justify-center py-3 px-3">
                <p className="font-acme text-2xl w-96 mb-2">
                  Please enter the child code.
                </p>
                <Input
                  value={code}
                  onChange={(e) => {
                    setCode(e.currentTarget.value);
                    setError("");
                  }}
                  placeholder="Code"
                />
                {error && (
                  <div className="font-acme text-red-700 text-2xl capitalize">
                    {error}
                  </div>
                )}
                {!isLoading ? (
                  <Button
                    className="!mt-8 !text-4xl btn"
                    onClick={connectChild}
                    btnType="green"
                    label="Submit"
                  />
                ) : (
                  <Loading type="spin" color="#002356" />
                )}
                {info?.data?.child_info?.length > 0 && (
                  <Button
                    className="!mt-8 !text-4xl btn"
                    btnType="green"
                    label="Goto parent page"
                    onClick={gotoParentPage}
                  />
                )}
              </div>
            </DataFrame>
            <div
              onClick={() => setHelpwindow(true)}
              className="text-4xl text-blue-900 underline font-bold font-acme underline-offset-4 capitalize cursor-pointer mt-5"
            >
              How to find your child's code?
            </div>
          </motion.div>
        )}

        {helpwindow && <TutorialFrame onClose={() => setHelpwindow(false)} />}
      </AnimatePresence>
    </div>
  );
}

export default ParentBinder;
